const COMBO_FIELDS = {
    // FROM MOTOR
    MOTOR: {
        FRONT_ID: 'frontId',
        ID: 'idCombo',
        NOME: 'nomeCombo',
        DESTAQUE: 'destaque',
        PERSONALIZADO: 'isPersonalizado',
        PARCELAMENTO: 'parcelamento',
        BENS: 'bens',
        PERC_PREJUIZO: 'percPrejuizo',
        PREMIO_TOTAL: 'premioTotal',
        PREMIO_EM_GARANTIA: 'premioEmGarantia',
        PREMIO_NAO_GARANTIA: 'premioNaoGarantia',
        PREMIO_TOTAL_COM_DESCONTO: 'premioTotalComDesconto',
        PREMIO_TOTAL_SISBB: 'premioTotalSISBB',
        VALOR_COMISSAO_BB_CORRETORA: 'valorComissaoBbCorretora',
        VALOR_COMISSAO_CORRETOR_1: 'valorComissaoCorretor1',
        VALOR_COMISSAO_CORRETOR_2: 'valorComissaoCorretor2',
        VALOR_COMISSAO_CORRETOR_3: 'valorComissaoCorretor3',
        VALOR_COMISSAO_TOTAL: 'valorComissaoTotal',
        MENSAGEM_DESCONTO: 'mensagemDesconto'
    },
    // SELECIONADO
    SELECIONADO: {
        THIS: 'comboSelecionado',
        PARCELA_GARANTIA: 'parcelaEmGarantia',
        HAS_PARCELAS_GARANTIA: 'hasParcelasEmGarantia',
        PARCELA_NAO_GARANTIA: 'parcelaNaoGarantia',
        HAS_PARCELAS_NAO_GARANTIA: 'hasParcelasEmNaoGarantia',
        ID: 'idCombo'
    }
};

export default COMBO_FIELDS;
